import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { token, user, isRefreshing } = useAuth();
  
  // Show loading while checking/refreshing token
  if (isRefreshing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600 dark:text-gray-400">Loading your data...</p>
        </div>
      </div>
    );
  }
  
  // If we have a token but no user data, something went wrong
  // This prevents showing empty dashboard - force re-login
  if (token && !user) {
    console.warn("⚠️ Token exists but user data missing - redirecting to login");
    // Clear the bad token
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("user");
    return <Navigate to="/login" replace />;
  }
  
  return token ? children : <Navigate to="/login" replace />;
}
